import { type QueryParams } from './querys';

export const ItemPriceQueryKey = (path: string, params: QueryParams) => ['price', 'list', path, params];
export const ItemStockQueryKey = (path: string, params: QueryParams) => ['price', 'stock', path, params];

export const CollectionQueryKey = (path: string, params: QueryParams) => ['collection', 'list', path, params];
export const collectionPriceQueryKey = (path: string, params: QueryParams) => ['collection', 'price', path, params];

export const ItemDictQueryKey = (path: string, params: QueryParams) => ['dict', 'list', path, params];
export const itemInfoDictQueryKey = (path: string, params: QueryParams) => ['detail', 'item', path, params];

export const itemInfoQueryKey = (path: string, params: QueryParams) => ['detail', 'item', path, params];
export const lowestQueryKey = (path: string, params: QueryParams) => ['detail', 'lowest', path, params];
export const priceStatsQueryKey = (path: string, params: QueryParams) => ['detail', 'pricestats', path, params];

export const notiListQueryKey = (path: string, params: QueryParams) => ['notisetting', 'item', path, params];
export const notiSearchQueryKey = (path: string, params: QueryParams) => ['notisetting', 'search', path, params];
export const lowestpriceQueryKey = (path: string, params: QueryParams) => ['notisetting', 'lowestprice', path, params];
export const notiItemInfoQueryKey = (path: string, params: QueryParams) => ['notisetting', 'notiItemInfo', path, params];

export const ServerListQueryKey = (path: string, params: QueryParams) => ['server', 'list'];
export const WorldServerListQueryKey = (path: string, params: QueryParams) => ['server', 'list', 'world'];

export const ItemDicQueryKey = (path: string, params: QueryParams) => ['dic', 'list', path, params];

export const SpellDictQueryKey = (path: string, params: QueryParams) => ['dict', 'spell', path, params];
